import { FunctionComponent, useState } from 'react';

// Components
import Select, { Props as SelectProps } from 'react-select';

// Utilities
import classnames from 'classnames';

// Style
import style from './Style.module.scss';
import { ActionMeta, OptionProps } from 'react-select/src/types';

interface ReactSelectProps {
    error?: boolean;
    errorMessage?: any;
    requiredMark?: boolean;
    errorClassName?: string;

    selectClassName?: string;
    selectErrorClassName?: string;
    selectFocusClassName?: string;

    labelClassName?: string;
    labelFloatClassName?: string;
}

const ReactSelect: FunctionComponent<ReactSelectProps & SelectProps> = ({
    error,
    className,
    errorMessage,
    requiredMark,
    errorClassName,
    labelClassName,
    selectClassName,
    placeholder: label,
    selectFocusClassName,
    selectErrorClassName,
    labelFloatClassName,
    ...props
}) => {
    const [isFocused, setIsFocused] = useState<boolean>(false);

    const hasValue = !!props.value && props.value['value'] !== '' && props.value['label'] !== '';

    const handleInputFocus = (event) => {
        setIsFocused(true);
        if (props.onFocus) {
            props.onFocus(event);
        }
    };

    const handleInputBlur = (event) => {
        setIsFocused(false);
        if (props.onBlur) {
            props.onBlur(event);
        }
    };

    const handleInputChange = (option: OptionProps, action: ActionMeta<any>) => {
        if (props.onChange) {
            props.onChange(option, action);
        }
    };

    const combinedInputClassName = classnames([
        style.select,
        selectClassName,
        {
            [style.error]: error,
            [selectErrorClassName]: !!selectErrorClassName && error,

            [style.focus]: isFocused,
            [selectFocusClassName]: !!selectFocusClassName && isFocused,
        },
    ]);

    const combinedLabelClassName = classnames([
        style.label,
        labelClassName,
        {
            [style.required]: !!requiredMark,
            [labelFloatClassName]: !!labelFloatClassName && (hasValue || isFocused),
        },
    ]);

    const combinedWrapperClassName = classnames([
        style.wrapper,
        className,
        {
            [style.float]: hasValue || isFocused,
        },
    ]);

    return (
        <>
            <div className={combinedWrapperClassName}>
                <label className={combinedLabelClassName}>{label}</label>

                <Select
                    {...props}
                    placeholder=""
                    instanceId="select"
                    onBlur={handleInputBlur}
                    onFocus={handleInputFocus}
                    onChange={handleInputChange}
                    className={combinedInputClassName}
                />
            </div>
            {errorMessage && (
                <div className={classnames([style.select_message_error, errorClassName])}>{errorMessage}</div>
            )}
        </>
    );
};

ReactSelect.defaultProps = {
    errorClassName: '',
    classNamePrefix: 'custom',
};

export default ReactSelect;
